import type { SessionResponse, SurveyResponse } from '@lms/api-client/backend';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@lms/ui/dialog';
import { useCallback, useEffect, useState } from 'react';
import { useTranslations } from 'use-intl';
import TakeSurveyForm from './take-survey-form';

declare global {
  interface Window {
    API: any;
    API_1484_11: any;
  }
}

export default function AfterSurvey({
  session,
  survey,
}: {
  session?: SessionResponse;
  survey: SurveyResponse;
}) {
  const t = useTranslations('player');
  const [showSurvey, setShowSurvey] = useState(false);

  const checkCompletion = useCallback(() => {
    if (window.API_1484_11.cmi.completion_status === 'completed') {
      setShowSurvey(true);
    }
  }, []);

  useEffect(() => {
    const timeout = setInterval(checkCompletion, 1000);
    return () => clearInterval(timeout);
  }, [checkCompletion]);

  useEffect(() => {
    // Mark CMI as "unsaved"
    window.API_1484_11.on('SetValue', function setValueListener() {
      checkCompletion();
    });

    window.API_1484_11.on('Terminate', function terminateListener() {
      checkCompletion();
    });
  }, [checkCompletion]);

  return (
    <Dialog open={showSurvey}>
      <DialogContent className="max-w-screen-md">
        <DialogHeader>
          <DialogTitle>{t('survey_after_title')}</DialogTitle>
        </DialogHeader>
        <TakeSurveyForm
          sessionId={session?.id}
          survey={survey}
          position="after_course"
        />
      </DialogContent>
    </Dialog>
  );
}
